/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FilterCriteriaInfo,
  FormateurHoraireIncoherenceGridDtoPaginatedResults,
  FormateurHoraireIncoherenceSearch,
  SelectItem,
  ValidationError,
} from '../models/index';
import {
    FilterCriteriaInfoFromJSON,
    FilterCriteriaInfoToJSON,
    FormateurHoraireIncoherenceGridDtoPaginatedResultsFromJSON,
    FormateurHoraireIncoherenceGridDtoPaginatedResultsToJSON,
    FormateurHoraireIncoherenceSearchFromJSON,
    FormateurHoraireIncoherenceSearchToJSON,
    SelectItemFromJSON,
    SelectItemToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models/index';

export interface FormateurHoraireIncoherenceBaseSearchRequest {
    FormateurHoraireIncoherenceSearch?: FormateurHoraireIncoherenceSearch;
}

export interface FormateurHoraireIncoherenceCalculCoherenceRequest {
    idFormateur?: number;
}

export interface FormateurHoraireIncoherenceGetSearchCriteriasRequest {
    includeListsValues?: boolean;
}

export interface FormateurHoraireIncoherenceGetSelectItemsRequest {
    searchField: string;
}

/**
 * 
 */
export class FormateurHoraireIncoherenceApi extends runtime.BaseAPI {

    /**
     */
    async formateurHoraireIncoherenceBaseSearchRaw(requestParameters: FormateurHoraireIncoherenceBaseSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormateurHoraireIncoherenceGridDtoPaginatedResults>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/FormateurHoraireIncoherence/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FormateurHoraireIncoherenceSearchToJSON(requestParameters.FormateurHoraireIncoherenceSearch),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FormateurHoraireIncoherenceGridDtoPaginatedResultsFromJSON(jsonValue));
    }

    /**
     */
    async formateurHoraireIncoherenceBaseSearch(requestParameters: FormateurHoraireIncoherenceBaseSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormateurHoraireIncoherenceGridDtoPaginatedResults> {
        const response = await this.formateurHoraireIncoherenceBaseSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async formateurHoraireIncoherenceCalculCoherenceRaw(requestParameters: FormateurHoraireIncoherenceCalculCoherenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidationError>> {
        const queryParameters: any = {};

        if (requestParameters.idFormateur !== undefined) {
            queryParameters['idFormateur'] = requestParameters.idFormateur;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/FormateurHoraireIncoherence/CalculCoherence`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidationErrorFromJSON(jsonValue));
    }

    /**
     */
    async formateurHoraireIncoherenceCalculCoherence(requestParameters: FormateurHoraireIncoherenceCalculCoherenceRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidationError> {
        const response = await this.formateurHoraireIncoherenceCalculCoherenceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async formateurHoraireIncoherenceGetSearchCriteriasRaw(requestParameters: FormateurHoraireIncoherenceGetSearchCriteriasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FilterCriteriaInfo>>> {
        const queryParameters: any = {};

        if (requestParameters.includeListsValues !== undefined) {
            queryParameters['includeListsValues'] = requestParameters.includeListsValues;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/FormateurHoraireIncoherence/criterias`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilterCriteriaInfoFromJSON));
    }

    /**
     */
    async formateurHoraireIncoherenceGetSearchCriterias(requestParameters: FormateurHoraireIncoherenceGetSearchCriteriasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilterCriteriaInfo>> {
        const response = await this.formateurHoraireIncoherenceGetSearchCriteriasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async formateurHoraireIncoherenceGetSelectItemsRaw(requestParameters: FormateurHoraireIncoherenceGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SelectItem>>> {
        if (requestParameters.searchField === null || requestParameters.searchField === undefined) {
            throw new runtime.RequiredError('searchField','Required parameter requestParameters.searchField was null or undefined when calling formateurHoraireIncoherenceGetSelectItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/FormateurHoraireIncoherence/criteriaList/{searchField}`.replace(`{${"searchField"}}`, encodeURIComponent(String(requestParameters.searchField))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SelectItemFromJSON));
    }

    /**
     */
    async formateurHoraireIncoherenceGetSelectItems(requestParameters: FormateurHoraireIncoherenceGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SelectItem>> {
        const response = await this.formateurHoraireIncoherenceGetSelectItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
